export default __webpack_public_path__ + "static/media/squish.45482f7e.mp3";